import type { Member, PerDiem, Supplier } from 'modules/payable/models';

import type {
  RawMember,
  RawSupplier,
  RawCounterparty,
  RawMileageDetails,
  RawPerDiem,
} from './query';

export const reshapeMember = (rawMember: RawMember): Member => {
  if (rawMember.__typename === 'User') {
    return {
      type: 'user',
      id: rawMember.id,
      givenName: rawMember.givenName,
      familyName: rawMember.familyName,
      email: rawMember.email,
      avatar: rawMember.avatar,
    };
  }
  if (rawMember.__typename === 'SuspendedUser') {
    return {
      type: 'suspendedUser',
      id: rawMember.id,
      givenName: rawMember.givenName,
      familyName: rawMember.familyName,
      avatar: undefined,
    };
  }
  return {
    type: 'invitee',
    id: rawMember.id,
    email: rawMember.email,
  };
};

export const reshapeSupplier = (rawSupplier: RawSupplier): Supplier => {
  return {
    id: rawSupplier.id,
    name: rawSupplier.name,
    thumbnailUrl: rawSupplier.thumbnailUrl,
  };
};

export const reshapeCounterparty = (
  rawCounterparty: RawCounterparty,
): Member | (Supplier & { type: 'supplier' }) => {
  if (rawCounterparty.__typename === 'Supplier') {
    return { type: 'supplier', ...reshapeSupplier(rawCounterparty) };
  }
  return reshapeMember(rawCounterparty);
};

export const reshapeMileageDetails = (rawMileageDetails: RawMileageDetails) => {
  return {
    distance: `${rawMileageDetails.distance.value}${rawMileageDetails.distance.unit}`,
  };
};

export const reshapePerDiem = (rawType: RawPerDiem): PerDiem => {
  return {
    duration: rawType.tripDays.length,
  };
};
